import { Dispatch, SetStateAction } from 'react';
import { BrandHealthEntry } from '@blisspointmedia/bpm-types/dist/BrandHealthMetrics';
import { Img } from '../../Components/Img';
import { FullPageSpinner } from '../../Components/Spinner/Spinner';
import { DateRange } from '../../utils/date-utils';
import { BrandMetricsContent } from './BrandMetricsContent';
import { FiltersPanel } from './FiltersPanel';

interface YouGovBrandHealthProps {
  focalAdvertiser: string;
  nonFocalAdvertisers: string[];
  data: BrandHealthEntry[];
  dateRange: DateRange | undefined;
  ageMap: Partial<Record<string, boolean>>;
  setAgeMap: (key: string, value: boolean) => void;
  genderMap: Partial<Record<string, boolean>>;
  setGenderMap: (key: string, value: boolean) => void;
  regionMap: Partial<Record<string, boolean>>;
  regionLabels: readonly string[];
  setRegionMap: (key: string, value: boolean) => void;
  incomeMap: Partial<Record<string, boolean>>;
  setIncomeMap: (key: string, value: boolean) => void;
  setFetchingData: Dispatch<SetStateAction<boolean>>;
  appliedFilters: Record<string, boolean | undefined>;
  inLoadingState: boolean;
}

export const YouGovBrandHealth = ({
  focalAdvertiser,
  nonFocalAdvertisers,
  data,
  dateRange,
  ageMap,
  setAgeMap,
  genderMap,
  setGenderMap,
  regionMap,
  regionLabels,
  setRegionMap,
  incomeMap,
  setIncomeMap,
  setFetchingData,
  appliedFilters,
  inLoadingState
}: YouGovBrandHealthProps) =>
  dateRange !== undefined ? (
    <div className='brand-health-metrics'>
      <div className='left-section'>
        <BrandMetricsContent
          focalAdvertiser={focalAdvertiser}
          nonFocalAdvertisers={nonFocalAdvertisers}
          type='Awareness'
          infoBarText='The percent of individuals that have ever heard of the brand.'
          toolTipText="Respondents to YouGov's survey are asked to select from a list of online brands which they have ever heard of."
          data={data}
          dateRange={dateRange}
        />
        <BrandMetricsContent
          focalAdvertiser={focalAdvertiser}
          nonFocalAdvertisers={nonFocalAdvertisers}
          type='Consideration'
          infoBarText='The percent of individuals that would consider visiting the brand online.'
          toolTipText="Respondents to YouGov's survey are asked to select from a list of online brands which they would consider visiting through desktop/laptop, tablet, or mobile phone."
          data={data}
          dateRange={dateRange}
        />
      </div>
      <div className='right-section'>
        <FiltersPanel
          ageMap={ageMap}
          setAgeMap={setAgeMap}
          genderMap={genderMap}
          setGenderMap={setGenderMap}
          regionMap={regionMap}
          regionLabels={regionLabels}
          setRegionMap={setRegionMap}
          incomeMap={incomeMap}
          setIncomeMap={setIncomeMap}
          setFetchingData={setFetchingData}
          appliedFilters={appliedFilters}
          inLoadingState={inLoadingState}
        />
        <div className='signature'>
          <div className='signature-label'>Powered By:</div>
          <div className='signature-image'>
            <Img src='https://cdn.blisspointmedia.com/assets/img/YouGov.png' />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <FullPageSpinner />
  );
